import "./contactus.css";
import React from "react";
import watsapp from "../../images/watsapp.png";

export default function Contactus() {
  return (
    <div className="contactus">
      <div className="wraperyacontactus">
        <div className="upperside2">
          <div className="talktous">Get in touch</div>
        </div>
        <div className="downside">
          <div className="reviews">
            <div className="messageobject">
              <h3>Call us on</h3>
              <h4>+254781198380</h4>
            </div>

            <div className="messageobject">
              <h3>Email Us</h3>
              <h4>acejayauto@gmail.com</h4>
            </div>

            <div className="messageobject">
              <h3>Watsapp</h3>
              <a target="_blank" href="https://wa.me/+254781198380">
                <img src={watsapp} alt="watsapp" />
              </a>
            </div>
          </div>
          <div className="leftside">
            <div className="clientmessage">
              <lebel>Topic:</lebel>
              <input
                type="text"
                placeholder="Type topic here"
                className="clientupdateinput"
              />
            </div>
            <div className="clientmessage">
              <lebel>Message</lebel>
              <textarea
                rows={10}
                cols={10}
                placeholder="Type message here"
                className="clientmessageinput"
              />
            </div>
          </div>
          <div className="contactform">
            <div className="clientupdateitem">
              <lebel>Name</lebel>
              <input
                type="text"
                placeholder="Amos Manyuru"
                className="clientupdateinput"
              />
            </div>
            <div className="clientupdateitem">
              <lebel>Email</lebel>
              <input
                type="text"
                placeholder="example@gmail.com"
                className="clientupdateinput"
              />
            </div>
            <div className="clientupdateitem">
              <lebel>Phone Number</lebel>
              <input
                type="text"
                placeholder="+254700000001"
                className="clientupdateinput"
              />
            </div>
            <div className="clientupdateitem">
              <lebel>Address</lebel>
              <input
                type="text"
                placeholder="Mombasa"
                className="clientupdateinput"
              />
            </div>
            <button className="submit">submit</button>
          </div>
        </div>
      </div>
    </div>
  );
}
